import { CountryCode, parsePhoneNumber } from 'libphonenumber-js';
import styled from 'styled-components';
import { FlagIcon } from 'ui/flags';
import { FlagIconCode } from 'ui/flags/flagIcons';
import { BaseOption } from 'ui/selects';
import { Body2, Caption, colors } from 'ui/theme';

const StyledFlagIcon = styled(FlagIcon)`
  display: flex;
`;

const SecondaryCaption = styled(Caption)`
  color: ${colors.textSecondary};
`;

const StyledBody2 = styled(Body2)`
  margin: 0;
`;

const toSelectOption = (
  {
    countryCode,
    countryName,
    callingCode,
  }: {
    countryCode: FlagIconCode;
    countryName: string;
    callingCode: string;
  },
  withCountryFlag?: boolean,
): BaseOption => ({
  id: countryCode,
  Suffix: <SecondaryCaption>{`+${callingCode}`}</SecondaryCaption>,
  value: countryCode,
  ...(withCountryFlag
    ? {
        Prefix: <StyledBody2>{countryName}</StyledBody2>,
        label: <StyledFlagIcon code={countryCode} />,
      }
    : {
        label: <StyledBody2>{countryName}</StyledBody2>,
      }),
});

export const getCountryOptions = (
  countryOptions: {
    countryCode: FlagIconCode;
    countryName: string;
    callingCode: string;
  }[],
  supportedCountries: string[] = [],
  searchText?: string,
  withCountryFlag?: boolean,
) => {
  return countryOptions
    .filter(
      (country) =>
        (!supportedCountries?.length || supportedCountries.includes(country.countryCode)) &&
        (!searchText ||
          country.countryCode.toLowerCase().includes(searchText) ||
          country.countryName.toLowerCase().includes(searchText)),
    )
    .map((country) => toSelectOption(country, withCountryFlag));
};

export const validateNumber = (
  phoneNumber: string,
  country: string,
  onError?: (e: Error) => void,
) => {
  try {
    const numericOnly = phoneNumber.replace(/\D/g, '');
    const parsed = parsePhoneNumber(numericOnly, country as CountryCode);
    const isPossible = parsed.isPossible();
    const isValid = parsed.isValid();
    const parsedNumberHasError = !isPossible || !isValid;
    if (parsedNumberHasError) {
      onError?.(new Error('Phone number is invalid for country'));
      return false;
    }
    return true;
  } catch (e) {
    onError?.(e as Error);
    return false;
  }
};
